
// Default locales and helpers
export const SUPPORTED_LOCALES = ["en", "de"];
export const DEFAULT_LOCALE = "en";

export function localeNameFromCode(code) {
  let name = null;

  switch (code) {
    case "en":
      name = "English"
      break;
    case "de":
      name = "Deutsch"
      break;
  
    default:
      break;
  }

  return name;
}